import { IMockStore } from '@graphql-tools/mock';

export const seed = (store: IMockStore) => {
  // Create two Clubs
  store.set('Club', 'club:1', {
    id: 'club:1',
    name: 'Royal Oaks',
    slug: 'royal-oaks',
    country: 'ES',
    foundedYear: 1980,
  });
  store.set('Club', 'club:2', {
    id: 'club:2',
    name: 'Green Valley',
    slug: 'green-valley',
    country: 'ES',
    foundedYear: 1992,
  });

  // A Course under club:1
  store.set('Course', 'course:1', {
    id: 'course:1',
    name: 'North Course',
    slug: 'north',
    club: store.get('Club', 'club:1'), // set by ref
  });

  // A Player attached to club:1
  store.set('Player', 'player:1', {
    id: 'player:1',
    firstName: 'Ana',
    lastName: 'García',
    license: 'ES-0001',
    club: store.get('Club', 'club:1'),
  });

  // A Tournament with a Round on course:1
  store.set('Tournament', 't:1', {
    id: 't:1',
    name: 'Open de Madrid',
    capacity: 120,
    players: 64,
    host: store.get('Club', 'club:1'),
    organizer: store.get('Club', 'club:2'),
  });
  store.set('Round', 'r:1', {
    id: 'r:1',
    ordinal: 1,
    tournament: store.get('Tournament', 't:1'),
    course: store.get('Course', 'course:1'),
  });
};
